import {TableColumn} from '@fl/cmsch-fe-library';

import {RolePermission} from 'api/gen/RolePermission';

/**
 * Columns used by the admin permissions table.
 *
 * @returns Static permissions table column definitions.
 */
export const getPermissionTableColumns: Array<TableColumn<RolePermission>> = [
    {
        field: 'code',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'controllerName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'actionName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'comment',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
];
